var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"app":"","dark":"","dense":""}},[_c('v-app-bar-nav-icon',{attrs:{"color":"primary"},on:{"click":_vm.toggleMenu}}),_c('v-spacer'),_c('header-search-bar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }